var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinishPrimary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-37.8%",
    y: "-27%",
    width: "175.7%",
    height: "175.7%",
    filterUnits: "objectBoundingBox",
    id: "t5bge0obga"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.105882353 0 0 0 0 0.218006792 0 0 0 0 0.447058824 0 0 0 0.1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-27.8%",
    y: "-21.9%",
    width: "155.7%",
    height: "143.8%",
    filterUnits: "objectBoundingBox",
    id: "3db2duqetd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-24.9%",
    y: "-22.8%",
    width: "149.9%",
    height: "145.7%",
    filterUnits: "objectBoundingBox",
    id: "xy3uyq4upf"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "gb6rf2mjhc",
    d: "M4.106 4.528h9.518v12.096H4.106z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0wkphqxpje",
    d: "M13.624 8.269h10.629v11.598l-10.63-.176 3.023-5.71z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "6vz7pxr3ob",
    x: 0,
    y: 0,
    width: 46.262,
    height: 46.262,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(10.345 5.007)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#t5bge0obga)",
    xlinkHref: "#6vz7pxr3ob"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#2D5FFB",
    xlinkHref: "#6vz7pxr3ob"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.181 14.088)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#gb6rf2mjhc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#3db2duqetd)",
    xlinkHref: "#gb6rf2mjhc"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#gb6rf2mjhc"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#162371",
    strokeWidth: 1.3,
    fill: "#F2F5FE",
    fillRule: "nonzero",
    d: "M24.287 14.088v29.965"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 29.029 21.112)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#0wkphqxpje"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#xy3uyq4upf)",
    xlinkHref: "#0wkphqxpje"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#0wkphqxpje"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#162371",
    strokeWidth: 1.3,
    d: "M20.75 44.16h7.514"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishPrimary);
export default __webpack_public_path__ + "static/media/finish-primary.2b08af9f3f67244a90f7cb71ed199671.svg";
export { ForwardRef as ReactComponent };